import Button from "../../../../components/button";

const WatchEventsButton = ({
  count,
  disabled,
  title,
  onClick,
  onContextMenu,
}) => {
  const safeCount = Number.isFinite(+count) ? +count : 0;

  return (
    <Button
      disabled={disabled ?? safeCount === 0}
      title={title || `Watch ${safeCount} events`}
      onClick={onClick}
      onContextMenu={onContextMenu}
    />
  );
};

export default WatchEventsButton;
